import React, { useState, useEffect, useContext } from 'react';
import { useTheme } from '@material-ui/styles';
import { useStyles } from '../styles';

import { Typography } from '@material-ui/core';

import Crud from '../crud';
import Quickcrumbs from '../../global/Quickcrumbs';


const CurrencySettings = props => {


    const theme = useTheme();
    const styles = useStyles(theme);

    return (
        <div className={styles.root}>
            <div className={styles.wrapper}>

                <Quickcrumbs 
                    crumbs={[
                        {
                            name: 'Settings',
                            route: '/settings'
                        },
                        {
                            name: 'Currencies',
                            route: '/settings/currencies'
                        }
                    ]}
                    history={props.history}
                />

                <div className={styles.taskbar}>
                    <Typography variant="h4">Currencies</Typography>
                </div>

                <Crud
                    heading='Currencies'
                    uri='currencies'
                    idCol='id_currency'
                    displayColumns={[
                        { 
                            name: 'code', 
                            type: 'string',
                            display_name: 'Code',
                            editable: true,
                            required: true
                        },
                        { 
                            name: 'symbol', 
                            type: 'string',
                            display_name: 'Symbol',
                            editable: true,
                            required: true
                        }
                    ]}
                    canRemove={false}
                />

            </div>

        </div>
    )

}

export default CurrencySettings
